import React from 'react';
import HeroSection from '../components/marketing/sections/HeroSection';
import HowItWorksSection from '../components/marketing/sections/HowItWorksSection';
import DemoSection from '../components/marketing/sections/DemoSection';
import ProblemSection from '../components/marketing/sections/ProblemSection';
import AudienceSection from '../components/marketing/sections/AudienceSection';
import FeaturesSection from '../components/marketing/sections/FeaturesSection';
import TrustSection from '../components/marketing/sections/TrustSection';
import FinalCTASection from '../components/marketing/sections/FinalCTASection';
import useDocumentMeta from '../hooks/useDocumentMeta';
import useReveal from '../hooks/useReveal';

const LandingPage = () => {
  const revealRef = useReveal();

  useDocumentMeta({
    title: 'Make every introduction count',
    description:
      'Velox captures the people you meet, keeps their details current, and helps you remember, find and follow up. Start with a profile; a contactless card is one way to share.',
    path: '/',
  });

  return (
    <div ref={revealRef}>
      <HeroSection />
      <HowItWorksSection />
      <DemoSection />
      <ProblemSection />
      <AudienceSection />
      <FeaturesSection />
      <TrustSection />
      <FinalCTASection />
    </div>
  );
};

export default LandingPage;
